import React from 'react'
import { Modal, Button } from 'semantic-ui-react'

const ConfirmModal = (props) => {
  const { message, onClose, onConfirm } = props
  return (
    <Modal open={!!message} size="small" onClose={onClose} className="confirm-modal">
      <Modal.Content>
        {message}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="red"
          onClick={() => {
            onConfirm()
            onClose()
          }}
        >
          Ano
        </Button>
        <Button basic onClick={onClose}>
          Ne
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

ConfirmModal.defaultProps = {
  message: '',
}

ConfirmModal.propTypes = {
  message: React.PropTypes.string,
  onConfirm: React.PropTypes.func.isRequired,
  onClose: React.PropTypes.func.isRequired,
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./src/browser/components/ConfirmModal.js